var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-expansion-panels', {
    attrs: {
      "flat": "",
      "tile": ""
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('v-expansion-panel', {
      key: index
    }, [_c('v-expansion-panel-header', [_c('v-row', {
      staticClass: "row--xs",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-avatar', {
      attrs: {
        "color": _vm.legacy ? '#085848' : 'primary',
        "size": "28"
      }
    }, [_c('span', {
      staticClass: "font-size-16 font-weight-bold white--text"
    }, [_vm._v("Q")])])], 1), _c('v-col', [_c('p', {
      staticClass: "page-text page-text--lg font-weight-medium grey-1--text"
    }, [_vm._v(" " + _vm._s(item.Q) + " ")])])], 1)], 1), _c('v-expansion-panel-content', [_c('v-row', {
      staticClass: "row--xs",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-avatar', {
      attrs: {
        "color": _vm.legacy ? '#B1972D' : 'grey',
        "size": "28"
      }
    }, [_c('span', {
      staticClass: "font-size-16 font-weight-bold white--text"
    }, [_vm._v("A")])])], 1), _c('v-col', {
      staticClass: "page-text page-text--lg",
      class: _vm.legacy ? 'grey-1--text' : ''
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.A)
      }
    }), item.children ? _c('div', {
      staticClass: "mt-12"
    }, _vm._l(item.children, function (child, index) {
      return _c('v-row', {
        key: index,
        attrs: {
          "no-gutters": ""
        }
      }, [child.name ? _c('v-col', {
        attrs: {
          "cols": "auto"
        }
      }, [_c('strong', [_vm._v(_vm._s(child.name) + ": ")])]) : _vm._e(), _c('v-col', [_vm._v(" " + _vm._s(child.text) + " ")])], 1);
    }), 1) : _vm._e()])], 1)], 1)], 1);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }